import { render, staticRenderFns } from "./services.vue?vue&type=template&id=94efdee4&scoped=true&"
var script = {}
import style0 from "./services.vue?vue&type=style&index=0&id=94efdee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94efdee4",
  null
  
)

export default component.exports